export const config = {
  data() {
    return {};
  },
  methods: {
    getDetail(type = null, isFirst) {
      this.pageLoading = true;
      let url = '/buz/commission/gradeProgramCommissionQuery';
      if ((this.editType == '2' || this.editType == '3') && this.formData.versionNo) {
        //修改未来版本 条件：未来版本 且 存在版本号
        url = '/buz/commission/gradeProgramCommissionQueryByVersion';
      }
      this.$http({
        url,
        type: 'GET',
        data: {
          versionNo: this.formData.versionNo,
          productCode: this.productInfo.code
        }
      }).then(res => {
        this.innerCommissionsColumns = [];
        this.formData.commissionNum = res.data.commissionNum;
        this.formData.templateId = res.data.templateId;
        this.formData.untilLastCommissionIndex = res.data.untilLastCommissionIndex;
        this.formData.productCode = res.data.productCode;
        this.formData.productId = res.data.productId;
        this.formData.tableData = res.data.commissionList || [];
       
        this.single = res.data.untilLastCommissionIndex > 0;
      
        let arr = [];
        if (res.data.commissionList && res.data.commissionList.length) {
          res.data.commissionList.forEach(item => {
            arr.push(...item.factors);
          });
        }
        let len =
          res.data.commissionList && res.data.commissionList.length && res.data.commissionList[0].innerCommissions
            ? res.data.commissionList[0].innerCommissions.length
            : res.data.commissionNum;

        for (let index = 0; index < len; index++) {
          this.innerCommissionsColumns[index] = {
            key: 'commission',
            title: index == 0 ? '首年（%）' : `第` + this.$units.numberTransform(index + 1) + `年（%）`,
            commissionIndex: index + 1,
            totalCommission: len,
            width: index + 1 == len ? (index > 4 ? 300 : 160) : 120
          };
        }
        if (isFirst && this.formData.tableData.length == 0) {
          this.copyProgram(999);
        }
        this.getProgramIdColumns(arr, type);
        this.pageLoading = false;
      });
    }
  }
};
